module.exports = __webpack_public_path__ + "assets/img/ComparisonBAIOS.27794a5d.png";